import axios from "axios";
import { supabase } from "../supabaseClient";

async function getProfessions() {
  const { data, error } = await supabase.from("Professions").select("*");
  if (data) return data;
  else throw error;
}
async function getNationality() {
  const { data, error } = await supabase.from("Nationality").select("*");
  if (data) return data;
  else throw error;
}
async function getNative() {
  const { data, error } = await supabase.from("Native").select("*");
  if (data) return data;
  else throw error;
}
async function getBudget() {
  const { data, error } = await supabase.from("Budget").select("*");
  if (data) return data;
  else throw error;
}
async function getProjects() {
  const { data, error } = await supabase
    .from("Projects")
    .select("*,Inventory!left(InventoryType(type))")
    .eq("isPublished", true)
    .eq("isVJ", true);
  if (data) return data;
  else throw error;
}
async function getAssignedProjects(cpId) {
  const { data, error } = await supabase
    .from("SustenanceCpRelations")
    .select("*,projectId(*,Inventory!left(InventoryType(type)))")
    .eq("projectId.isPublished", true)
    .eq("projectId.isVJ", true)
    .eq("cpId", cpId);
  if (data) return data;
  else throw error;
}
async function getProjectUnitType(projectId) {
  const { data, error } = await supabase.rpc("getuniqueunittypes", {
    pid: projectId,
  });
  if (data) return data;
  else throw error;
}
// async function checkPersonExists(emailId) {
//   console.log(emailId);
//   const { data, error } = await supabase
//     .from('Person')
//     .select('*,Nationality(*),Professions(*),ProjectPreference(*)').match({ email: emailId })
//   if (data) return data;
//   else throw error;
// }
async function checkPhoneNumberExists(number) {
  const { data, error } = await supabase
    .from("Person")
    .select("*")
    .eq("contactNumber", number);
  if (data) return data;
  else throw error;
}
async function checkPhoneNumberIsBlackListed(number) {
  number = number.substring(1);
  console.log(number);
  const { data, error } = await supabase
    .from("BlacklistNumbers")
    .select("number")
    .eq("number", number);
  if (data) return data;
  else throw error;
}
async function addPersonTable(personalDetail, generalDetails) {
  const { data, error } = await supabase.from("Person").insert([
    {
      name: personalDetail.name.toUpperCase().replace(/\s\s+/g, " "),
      contactNumber: personalDetail.phoneNumber,
      gender: personalDetail.gender,
      email: personalDetail.email.toLowerCase(),
      nationalityId: generalDetails.nationality,
      nativeId: generalDetails.native,
      professionId: generalDetails.worksIn,
      budgetId: generalDetails.budget,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function addLeadsTable(personId, cpId, fosId, projectHead) {
  const { data, error } = await supabase.from("Leads").insert([
    {
      personId: personId,
      cpId: cpId,
      fosId: fosId,
      leadType: "CP",
      leadResponse: "WARM",
      projectHead: projectHead,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function addLeadStatus(leadId) {
  const { data, error } = await supabase.from("LeadStatus").insert([
    {
      leadId: leadId,
      status: "Unclaimed",
    },
  ]);
  if (data) return data;
  else throw error;
}
async function getLeadProjectPrefernce(personId) {
  const { data, error } = await supabase
    .from("Person")
    .select("*,ProjectPreference(*)")
    .order("created_at", { ascending: false })
    .eq("personId", personId);
  if (data) return data;
  else throw error;
}
async function addProjectPrefernces(projectObject, personId) {
  const { data, error } = await supabase.from("ProjectPreference").insert([
    {
      projectName: projectObject.selectedProject,
      unitType: projectObject.flatUnitType,
      dateTime: projectObject.SitePrefernces,
      isPrimary: projectObject.isPrimary,
      personId: personId,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function updateProjectPrefernce(projectPreferenceId, isPrimary) {
  const { data, error } = await supabase
    .from("ProjectPreference")
    .update({ isPrimary: isPrimary, last_updated_at: Date.now() })
    .eq("projectPreferenceId", projectPreferenceId);
  if (data) return data;
  else throw error;
}
async function addKYCDoc(leadId, panNumber, panName, panObject) {
  const { data, error } = await supabase.from("KycDocuments").insert([
    {
      leadId: leadId,
      docType: "PanCard",
      docNumber: panNumber,
      docHolderName: panName.toUpperCase().replace(/\s\s+/g, " "),
      docUrl: "",
      otherDetails: panObject,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function getLeads(
  cpId,
  fosId,
  from,
  to,
  selectedSales,
  selectedProjects,
  selectedStatus,
  selectDate,
  selectedDates,
  search,
  drpDownSelectedVal
) {
  console.log({ drpDownSelectedVal });
  const filters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };
  if (fosId === undefined) {
    fosId = null;
  }
  if (cpId === undefined) {
    cpId = null;
  }
  if (search === "" || search === undefined) {
    search = null;
  }

  console.log(filters[drpDownSelectedVal].key);
  var query;
  query = supabase
    .rpc("leadsfilter", {}, { count: "exact" })
    .order(filters[drpDownSelectedVal].key, {
      ascending: filters[drpDownSelectedVal].isAscending,
    })
    .range(from, to);
  //user loggedIn type
  if (fosId) {
    console.log("IN FOS BLOCK=================>", fosId, cpId);
    query = query.eq("fosid", fosId).eq("cpid", cpId);
  } else {
    query = query.eq("cpid", cpId);
  }
  if (search !== null) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("leadname", `%${search}%`);
  }
  if (selectedSales.length !== 0) {
    console.log(selectedSales);
    query = query.in("salesid", selectedSales);
  }
  if (selectedProjects.length !== 0) {
    console.log(selectedProjects);
    query = query.in("projectname", selectedProjects);
  }
  if (selectedStatus.length !== 0) {
    console.log(selectedSales);
    query = query.in("leadstatus", selectedStatus);
  }
  if (selectedDates !== null) {
    console.log(selectedDates);
    query = query
      .gte("created_at", new Date(selectDate[0].value).getTime())
      .lte("created_at", new Date(selectDate[1].value).getTime());
  }
  const { data, count, error } = await query;
  console.log("leads", data);
  if (data) return { data, count };
  else throw error;
}
async function getUsers() {
  const { data, error } = await supabase.from("Users").select("*");
  if (data) return data;
  else throw error;
}

async function getAllProjects() {
  const { data, error, count } = await supabase
    .from("Projects")
    .select("*", { count: "exact" })
    .eq("isVJ", true)
    .order("created_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}
async function getAllEvents(cpId) {
  // const { data, error, count } = await supabase.from('Events')
  // .select('*,Launches(title,launchId,projectId(addressLine1,addressLine2,addressLine3,city,country,latitude,longitude,pincode,projectName))!left(*)', {count: 'exact'}).eq('isPublished', true);
  const { data, error, count } = await supabase
    .rpc("cpeventcard", { myid: cpId }, { count: "exact" })
    .order("created_at", { ascending: false });
  if (data) return { data, count };
  else throw error;
}
async function getTotalLeadsCount(cpId, fosId) {
  var query;
  if (fosId) {
    query = await supabase
      .from("Leads")
      .select(`*`, { count: "exact" })
      .eq("fosId", fosId);
  } else {
    query = await supabase
      .from("Leads")
      .select(`*`, { count: "exact" })
      .eq("cpId", cpId);
  }
  const { data, error, count } = query;
  if (data) return { data, count };
  else throw error;
}
async function getSiteVisitsCount(cpId, fosId) {
  var query;
  if (fosId) {
    query = await supabase
      .from("SiteVisits")
      .select(`*`, { count: "exact" })
      .eq("fosId", fosId);
  } else {
    query = await supabase
      .from("SiteVisits")
      .select(`*`, { count: "exact" })
      .eq("cpId", cpId);
  }
  const { data, error, count } = query;
  if (data) return { data, count };
  else throw error;
}
async function getTokensCount(cpId, fosId) {
  var query;
  if (fosId) {
    query = await supabase
      .from("Leads")
      .select("*,EventTokenLeadRelations!left(leadId)", { count: "exact" })
      .eq("cpId", cpId)
      .eq("fosId", fosId);
  } else {
    query = await supabase
      .from("Leads")
      .select("*,EventTokenLeadRelations!left(leadId)", { count: "exact" })
      .eq("cpId", cpId);
  }
  /*select COUNT(*) from "EventTokenLeadRelations" as t1
    left join "Leads" as t2 on t1."leadId" = t2."leadId"
    where t2."cpId" = 'acde376e-7b52-485d-8ac4-0d8b08326525';*/
  const { data, error, count } = query;
  if (data) return { data, count };
  else throw error;
}
async function getAllAllotmentsCount(cpId, fosId) {
  var query;
  if (fosId) {
    query = await supabase
      .from("AllotmentPayment")
      .select("*,Leads!left(leadId)", { count: "exact" })
      .eq("Leads.cpId", cpId)
      .eq("Leads.fosId", fosId);
  } else {
    query = await supabase
      .from("AllotmentPayment")
      .select("*,Leads!left(leadId)", { count: "exact" })
      .eq("Leads.cpId", cpId);
  }
  /*select COUNT(*) from "EventTokenLeadRelations" as t1
    left join "Leads" as t2 on t1."leadId" = t2."leadId"
    where t2."cpId" = 'acde376e-7b52-485d-8ac4-0d8b08326525';*/
  const { data, error, count } = query;
  if (data) return { data, count };
  else throw error;
}
async function getAllAgreementCount(cpId, fosId) {
  var query;
  if (fosId) {
    query = await supabase
      .from("AllotmentPayment")
      .select("*,Leads!left(*)", { count: "exact" })
      .eq("Leads.cpId", cpId)
      .eq("Leads.fosId", fosId);
    // .eq('Leads')
  } else {
    query = await supabase
      .from("AllotmentPayment")
      .select("*,Leads!left(*)", { count: "exact" })
      .eq("Leads.cpId", cpId);
  }
  /*select COUNT(*) from "EventTokenLeadRelations" as t1
    left join "Leads" as t2 on t1."leadId" = t2."leadId"
    where t2."cpId" = 'acde376e-7b52-485d-8ac4-0d8b08326525';*/
  const { data, error, count } = query;
  if (data) return { data, count };
  else throw error;
}

async function getProjectsList(from, to, search, drpDownSelectedVal, cpId) {
  const filters = {
    "Name Ascending": {
      key: "projectId.projectName",
      isAscending: true,
    },
    "Name Descending": {
      key: "projectId.projectName",
      isAscending: false,
    },
    "Oldest First": {
      key: "created_at",
      isAscending: true,
    },
    "Latest First": {
      key: "created_at",
      isAscending: false,
    },
  };
  const query = await supabase
    .from("SustenanceCpRelations")
    // inner join so rows of JD / Landowner projects (isVJ = false) are removed; the page reads row.projectId.*
    .select("*,projectId!inner(*)", { count: "exact" })
    .eq("projectId.isVJ", true)
    .ilike("projectId.projectName", `%${search}%`)
    .range(from, to)
    .order(filters[drpDownSelectedVal].key, {
      ascending: filters[drpDownSelectedVal].isAscending,
    })
    .eq("cpId", cpId);
  const { data, count, error } = query;
  if (data) return { data, count };
  else throw error;
}
async function getFormatedEmail(type) {
  let query = supabase
    .from("EmailSmsTemplates")
    .select("*", { count: "exact" })
    .eq("type", type);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function addLeadLogs(obj) {
  const { data, error } = await supabase.from("LeadLogs").insert([
    {
      ...obj,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function checkLeadEmailExists(email) {
  const { data, error } = await supabase
    .from("Person")
    .select("email")
    .eq("email", email);
  if (data) return data;
  else throw error;
}
async function checkLeadEmailExistsInUsers(email) {
  const { data, error } = await supabase
    .from("Users")
    .select("email")
    .eq("email", email);
  if (data) return data;
  else throw error;
}
async function checkLeadEmailExistsInCp(email) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("email")
    .eq("email", email);
  if (data) return data;
  else throw error;
}

async function getAllotedData(leadId) {
  const { data, count, error } = await supabase
    .from("AllotmentPayment")
    .select(
      "*,inventoryMergedId(*,projectId(*),unit1Id(*,wingId(*)),unit2Id(*,wingId(*))),unitId(*,projectId!left(*),wingId(*)),CRM!left(*)",
      { count: "exact" }
    )
    .order("last_updated_at", { ascending: false })
    .eq("leadId", leadId);
  if (data) return { data, count };
  else throw error;
}
async function getLeadDetails(leadId) {
  const { data, error } = await supabase
    .from("Leads")
    .select(`*`)
    .eq("leadId", leadId);
  if (data) return { data };
  else throw error;
}



// async function getAgreementDoneLeads(CpId ,selectedProjects = []) {
//   // Step 1: Fetch CpPayments
//   const { data: cpPayments, count, error } = await supabase
//     .from('CpPayments')
//     .select('*')
//     .eq('CpId', CpId);

//   if (error) throw error;

//   const uniqueAllotmentPaymentIds = [...new Set(cpPayments.map(cp => cp.allotmentPaymentId))];
//   const processedAllotmentIds = new Set();

//   // Step 2: Fetch AllotmentPayments
//   const { data: allotmentPayments, error: allotmentError } = await supabase
//     .from('AllotmentPayment')
//     .select('*')
//     .in('allotmentPaymentId', uniqueAllotmentPaymentIds);

//   if (allotmentError) throw allotmentError;

//   const allotmentPaymentMap = allotmentPayments.reduce((acc, ap) => {
//     acc[ap.allotmentPaymentId] = ap;
//     return acc;
//   }, {});

//   // Step 3: Fetch Leads
//   const leadIds = [...new Set(allotmentPayments.map(ap => ap.leadId))];
//   const { data: leads, error: leadsError } = await supabase
//     .from('Leads')
//     .select('leadId, personId, leadDisplayId, fosId')
//     .in('leadId', leadIds);

//   if (leadsError) throw leadsError;

//   // Step 4: Fetch Persons
//   const personIds = [...new Set(leads.map(lead => lead.personId))];
//   const { data: persons, error: personsError } = await supabase
//     .from('Person')
//     .select('*')
//     .in('personId', personIds);

//   if (personsError) throw personsError;

//   // Step 5: Fetch Inventory
//   const unitIds = [...new Set(allotmentPayments.map(ap => ap.unitId))];
//   const { data: inventoryData, error: inventoryError } = await supabase
//     .from('Inventory')
//     .select('unitId, projectId, wingId, floorNo, unitNo')
//     .in('unitId', unitIds);

//   if (inventoryError) throw inventoryError;

//   // Step 6: Fetch Project and Wing data
//   const projectIds = [...new Set(inventoryData.map(i => i.projectId))];
//   const wingIds = [...new Set(inventoryData.map(i => i.wingId))];

//   const { data: projects, error: projectsError } = await supabase
//     .from('Projects')
//     .select('*')
//     .in('projectId', projectIds);

//   if (projectsError) throw projectsError;

//   const { data: wings, error: wingsError } = await supabase
//     .from('Wings')
//     .select('*')
//     .in('wingId', wingIds);

//   if (wingsError) throw wingsError;

//   // Step 7: Fetch FOS (handle nulls gracefully)
//   const fosIds = [...new Set(leads.map(l => l.fosId).filter(Boolean))]; // only non-null
//   const { data: fosData, error: fosError } = await supabase
//     .from('FOS')
//     .select('*')
//     .in('fosId', fosIds);

//   if (fosError) throw fosError;

//   // Step 8: Combine everything
//   const cpPaymentsWithDetails = cpPayments.map(cp => {
//     const allotment = allotmentPaymentMap[cp.allotmentPaymentId];
//     if (!allotment) return null;

//     const lead = leads.find(l => l.leadId === allotment.leadId);
//     if (!lead) return null;

//     const person = persons.find(p => p.personId === lead.personId) || null;
//     const inventory = inventoryData.find(i => i.unitId === allotment.unitId) || null;

//     const project = inventory
//       ? projects.find(p => p.projectId === inventory.projectId) || null
//       : null;

//     const wing = inventory
//       ? wings.find(w => w.wingId === inventory.wingId) || null
//       : null;

//     const fos = lead.fosId
//       ? fosData.find(f => f.fosId === lead.fosId) || null
//       : null;

//     if (processedAllotmentIds.has(cp.allotmentPaymentId)) return null;
//     processedAllotmentIds.add(cp.allotmentPaymentId);

//     return {
//       ...cp,
//       allotmentPaymentData: allotment,
//       leadData: lead,
//       personData: person,
//       inventoryDataForLead: inventory,
//       projectData: project,
//       wingData: wing,
//       fosData: fos,
//     };
//   });

//    const filteredResult = cpPaymentsWithDetails
//     .filter(Boolean)
//     .filter(item => {
//       if (selectedProjects.length === 0) return true;
//       return item.projectData && selectedProjects.includes(item.projectData.projectName);
//     });

//   return { data: filteredResult, count: filteredResult.length };


// }


// async function getAgreementDoneLeads(CpId,  selectedStatus = [] , selectedDates = null) {
//   // Step 1: Fetch CpPayments
//   const { data: cpPayments, error } = await supabase
//     .from('CpPayments')
//     .select('*')
//     .eq('CpId', CpId);

//   if (error) throw error;

//   const uniqueAllotmentPaymentIds = [
//     ...new Set(cpPayments.map((cp) => cp.allotmentPaymentId)),
//   ];
//   const processedAllotmentIds = new Set();

//   // Step 2: Fetch AllotmentPayments
//   const { data: allotmentPayments, error: allotmentError } = await supabase
//     .from("AllotmentPayment")
//     .select("*")
//     .in("allotmentPaymentId", uniqueAllotmentPaymentIds);

//   if (allotmentError) throw allotmentError;

//   const allotmentPaymentMap = allotmentPayments.reduce((acc, ap) => {
//     acc[ap.allotmentPaymentId] = ap;
//     return acc;
//   }, {});

//   // Step 3: Fetch Leads with status
//   const leadIds = [...new Set(allotmentPayments.map(ap => ap.leadId))];
//   const { data: leads, error: leadsError } = await supabase
//     .from('Leads')
//     .select('leadId, personId, leadDisplayId, fosId') // Include status
//     .in('leadId', leadIds);

//   if (leadsError) throw leadsError;

//   // Step 4: Fetch Persons
//   const personIds = [...new Set(leads.map((lead) => lead.personId))];
//   const { data: persons, error: personsError } = await supabase
//     .from("Person")
//     .select("*")
//     .in("personId", personIds);

//   if (personsError) throw personsError;

//   // Step 5: Fetch Inventory
//   const unitIds = [...new Set(allotmentPayments.map((ap) => ap.unitId))];
//   const { data: inventoryData, error: inventoryError } = await supabase
//     .from("Inventory")
//     .select("unitId, projectId, wingId, floorNo, unitNo")
//     .in("unitId", unitIds);

//   if (inventoryError) throw inventoryError;

//   // Step 6: Fetch Projects and Wings
//   const projectIds = [...new Set(inventoryData.map(i => i.projectId))];
//   const wingIds = [...new Set(inventoryData.map(i => i.wingId))];

//   const { data: projects } = await supabase
//     .from('Projects')
//     .select('*')
//     .in('projectId', projectIds);

//   const { data: wings } = await supabase
//     .from('Wings')
//     .select('*')
//     .in('wingId', wingIds);

//   const fosIds = [...new Set(leads.map(l => l.fosId).filter(Boolean))];
//   const { data: fosData } = await supabase
//     .from('FOS')
//     .select('*')
//     .in('fosId', fosIds);

//   // Combine everything
//   const cpPaymentsWithDetails = cpPayments.map(cp => {
//     const allotment = allotmentPaymentMap[cp.allotmentPaymentId];
//     if (!allotment) return null;

//     const lead = leads.find((l) => l.leadId === allotment.leadId);
//     if (!lead) return null;

//     const person = persons.find(p => p.personId === lead.personId) || null;
//     const inventory = inventoryData.find(i => i.unitId === allotment.unitId) || null;
//     const project = inventory ? projects.find(p => p.projectId === inventory.projectId) || null : null;
//     const wing = inventory ? wings.find(w => w.wingId === inventory.wingId) || null : null;
//     const fos = lead.fosId ? fosData.find(f => f.fosId === lead.fosId) || null : null;

//     if (processedAllotmentIds.has(cp.allotmentPaymentId)) return null;
//     processedAllotmentIds.add(cp.allotmentPaymentId);

//     return {
//       ...cp,
//       allotmentPaymentData: allotment,
//       leadData: lead,
//       personData: person,
//       inventoryDataForLead: inventory,
//       projectData: project,
//       wingData: wing,
//       fosData: fos,
//     };
//   });

//  // Step 8: Prepare Date Filtering
//   let startDate = null;
//   let endDate = null;
//   if (selectedDates && selectedDates.length === 2) {
//     startDate = selectedDates[0]?.value || null;
//     endDate = selectedDates[1]?.value || null;
//   }

//   // Step 9: Final Filtering
//   const filteredResult = cpPaymentsWithDetails
//     .filter(Boolean)
//     .filter(item => {
//       const matchesStatus =
//         selectedStatus.length === 0 ||
//         (item && selectedStatus.includes(item.Status));

//       const agreementDate = item?.AgreementDate; 
//       const matchesDate =
//         (!startDate || new Date(agreementDate) >= new Date(startDate)) &&
//         (!endDate || new Date(agreementDate) <= new Date(endDate));

//       return matchesStatus && matchesDate;
//     });

//   return { data: filteredResult, count: filteredResult.length };
// }

async function getAgreementDoneLeads(CpId, selectedStatus = [], selectedDates = null, searchText = "") {
  const normalizedSearch = searchText?.toLowerCase().trim();
  const isSearching = !!normalizedSearch;

  // Step 1: CpPayments
  const { data: allCpPayments, error } = await supabase
    .from('CpPayments')
    .select('*')
    .eq('CpId', CpId);
  if (error) throw error;

  // Soft-deleted entries (isDeleted = true, Status = "Deleted") are kept as
  // history and must not appear in the Agreement tab. Filtering here (rather
  // than after the merge) also stops a deleted row from winning the
  // per-allotment dedupe below over the fresh entry the cron regenerates.
  const cpPayments = (allCpPayments || []).filter(
    cp =>
      cp.isDeleted !== true &&
      String(cp.Status || "").toLowerCase().trim() !== "deleted"
  );

  const { data: cpBookingState, error: cpBookingError } = await supabase
    .from("CpBookingComputState")
    .select("*")
    .eq("cp_id", CpId);

  if (cpBookingError) throw cpBookingError;

  const cpBookingMap = {};

  (cpBookingState || []).forEach(item => {
    const planId = item.aop_plan_id || item.pop_plan_id;
    const key = `${item.cp_id}_${item.project_id}_${planId}`;

    if (!cpBookingMap[key]) {
      cpBookingMap[key] = [];
    }

    cpBookingMap[key].push(item);
  });

  // ✅ STEP 1.1: Fetch AOP plans
  const { data: aopPlans } = await supabase
    .from("aop_plans")
    .select("id, financial_year, validity_start_date, validity_end_date");

  // ✅ STEP 1.2: Fetch POP plans
  const { data: popPlans } = await supabase
    .from("pop_plans")
    .select("id, name, start_date, end_date");

  // const uniqueAllotmentPaymentIds = [...new Set(cpPayments.map(cp => cp.allotmentPaymentId))];
  const uniqueAllotmentPaymentIds = [
    ...new Set([
      ...cpPayments
        .map(cp => cp.allotmentPaymentId)
        .filter(id => id && id !== "null"),

      ...cpBookingState
        .map(item => item.allotment_payment_id)
        .filter(Boolean),
    ]),
  ];
  const processedAllotmentIds = new Set();


  // ✅ Create plan maps
  const aopPlanMap = {};
  (aopPlans || []).forEach(p => {
    aopPlanMap[p.id] = p; // ✅ full object
  });

  const popPlanMap = {};
  (popPlans || []).forEach(p => {
    popPlanMap[p.id] = p;   // ✅ store full object
  });
  // Step 2: AllotmentPayments
  const { data: allotmentPayments, error: allotmentError } = await supabase
    .from("AllotmentPayment")
    .select("*")
    .in("allotmentPaymentId", uniqueAllotmentPaymentIds);
  if (allotmentError) throw allotmentError;

  // Fetch AgreementForm for agreement dates (keyed by allotmentPaymentId)
  const { data: agreementForms } = await supabase
    .from("AgreementForm")
    .select("agreementFormId, allotmentPaymentId, agreementStatus")
    .in("allotmentPaymentId", uniqueAllotmentPaymentIds);

  const agreementFormMap = {};
  const agreementFormIdMap = {}; // allotmentPaymentId → agreementFormId
  (agreementForms || []).forEach(af => {
    agreementFormMap[af.allotmentPaymentId] = af.agreementStatus?.agreement_date || null;
    if (af.agreementFormId) agreementFormIdMap[af.allotmentPaymentId] = af.agreementFormId;
  });

  // Fetch primary applicant name from Applicants table.
  //
  // The name shown on the invoice annexure must be the applicant flagged
  // type === "first". This query previously selected no `type`, applied no
  // ORDER BY, and kept whichever row arrived first -- which without ordering is
  // the database's heap order, not the primary applicant. It was right about
  // 75% of the time because rows usually come back in insertion order, but on
  // agreements whose rows had since moved it printed the second or third
  // applicant instead (e.g. an annexure showing SURESH SHESHARAM CHAUDHARI,
  // type "third", where the first applicant was TULSARAM NATHARAM CHOUDHARI).
  const uniqueAgreementFormIds = [...new Set(Object.values(agreementFormIdMap))];
  const applicantNameMap = {}; // allotmentPaymentId → full name string
  if (uniqueAgreementFormIds.length > 0) {
    const { data: applicantsData } = await supabase
      .from("Applicants")
      .select("agreementFormId, applicant, type")
      .in("agreementFormId", uniqueAgreementFormIds)
      // Deterministic order, so the fallback below is stable across renders
      // instead of depending on the order rows happen to be returned in.
      .order("created_at", { ascending: true });

    const fullName = (a) =>
      [a?.firstName, a?.middleName, a?.lastName].filter(Boolean).join(" ").trim() || null;

    // Build a map: agreementFormId → full name, preferring type "first".
    // A non-first applicant is used only when the agreement has no "first" row
    // at all, and is then the earliest by created_at rather than an arbitrary one.
    const formIdToName = {};
    const formIdHasFirst = {};
    (applicantsData || []).forEach(row => {
      if (!row.applicant || !row.agreementFormId) return;

      const isFirst = String(row.type).toLowerCase() === "first";

      // A "first" applicant is already recorded; nothing can override it.
      if (formIdHasFirst[row.agreementFormId]) return;

      const name = fullName(row.applicant);
      if (!name) return;

      // Keep the earliest row seen so far unless this one is the "first" applicant.
      if (formIdToName[row.agreementFormId] && !isFirst) return;

      formIdToName[row.agreementFormId] = name;
      if (isFirst) formIdHasFirst[row.agreementFormId] = true;
    });

    // Map back to allotmentPaymentId
    Object.entries(agreementFormIdMap).forEach(([apId, afId]) => {
      if (formIdToName[afId]) applicantNameMap[apId] = formIdToName[afId];
    });
  }

  const allotmentPaymentMap = allotmentPayments.reduce((acc, ap) => {
    acc[ap.allotmentPaymentId] = ap;
    return acc;
  }, {});

  // Step 3: Leads
  const leadIds = [...new Set(allotmentPayments.map(ap => ap.leadId))];
  const { data: leads, error: leadsError } = await supabase
    .from('Leads')
    .select('leadId, personId, leadDisplayId, fosId')
    .in('leadId', leadIds);
  if (leadsError) throw leadsError;

  // Step 4: Persons
  const personIds = [...new Set(leads.map(l => l.personId))];
  const { data: persons, error: personsError } = await supabase
    .from("Person")
    .select("*")
    .in("personId", personIds);
  if (personsError) throw personsError;

  // Step 5: Inventory
  const unitIds = [...new Set(allotmentPayments.map(ap => ap.unitId))];
  const { data: inventoryData, error: inventoryError } = await supabase
    .from("Inventory")
    .select("*")
    .in("unitId", unitIds);
  if (inventoryError) throw inventoryError;

  // Step 6: Projects and Wings
  // const projectIds = [...new Set(inventoryData.map(i => i.projectId))];
  const projectIds = [
    ...new Set([
      ...inventoryData.map(i => i.projectId),
      ...cpPayments.map(cp => cp.projectId).filter(Boolean)
    ])
  ];
  const wingIds = [...new Set(inventoryData.map(i => i.wingId))];

  const { data: projects } = await supabase.from("Projects").select("*").in("projectId", projectIds);
  const { data: wings } = await supabase.from("Wings").select("*").in("wingId", wingIds);

  // Step 7: FOS
  const fosIds = [...new Set(leads.map(l => l.fosId).filter(Boolean))];
  const { data: fosData } = await supabase.from("FOS").select("*").in("fosId", fosIds);

  // Step 8: Combine all
  // const cpPaymentsWithDetails = cpPayments.map(cp => {
  //   const allotment = allotmentPaymentMap[cp.allotmentPaymentId];
  //   if (!allotment) return null;

  //   const lead = leads.find(l => l.leadId === allotment.leadId);
  //   if (!lead) return null;

  //   const person = persons.find(p => p.personId === lead.personId) || null;
  //   const inventory = inventoryData.find(i => i.unitId === allotment.unitId) || null;
  //   const project = inventory ? projects.find(p => p.projectId === inventory.projectId) : null;
  //   const wing = inventory ? wings.find(w => w.wingId === inventory.wingId) : null;
  //   const fos = lead.fosId ? fosData.find(f => f.fosId === lead.fosId) : null;

  //   if (processedAllotmentIds.has(cp.allotmentPaymentId)) return null;
  //   processedAllotmentIds.add(cp.allotmentPaymentId);

  //   return {
  //     ...cp,
  //     allotmentPaymentData: allotment,
  //     leadData: lead,
  //     personData: person,
  //     inventoryDataForLead: inventory,
  //     projectData: project,
  //     wingData: wing,
  //     fosData: fos,
  //   };
  // });



  const cpPaymentsWithDetails = cpPayments.map(cp => {
    const isAgreement = !!cp.allotmentPaymentId;
    const isAOP = cp.BrokerageType === "AOP" || cp.aopId;
    const isPOP = cp.BrokerageType === "POP" || cp.popId;

    // ✅ Project from CpPayments (IMPORTANT)
    let project = null;

    // ✅ For Agreement → use old logic (DO NOT BREAK)
    if (cp.allotmentPaymentId) {
      const allotment = allotmentPaymentMap[cp.allotmentPaymentId];
      const inventory = allotment
        ? inventoryData.find(i => i.unitId === allotment.unitId)
        : null;

      project = inventory
        ? projects.find(p => p.projectId === inventory.projectId)
        : null;
    }

    // ✅ For AOP / POP → use cp.projectId
    else if (cp.projectId) {
      project = projects.find(p => p.projectId === cp.projectId);
    }

    // -------------------------
    // ✅ AGREEMENT FLOW
    // -------------------------
    if (isAgreement) {
      const allotment = allotmentPaymentMap[cp.allotmentPaymentId];
      if (!allotment) return null;

      const lead = leads.find(l => l.leadId === allotment.leadId);
      if (!lead) return null;

      const person = persons.find(p => p.personId === lead.personId) || null;
      const inventory = inventoryData.find(i => i.unitId === allotment.unitId) || null;
      const wing = inventory ? wings.find(w => w.wingId === inventory.wingId) : null;
      const fos = lead.fosId ? fosData.find(f => f.fosId === lead.fosId) : null;

      if (processedAllotmentIds.has(cp.allotmentPaymentId)) return null;
      processedAllotmentIds.add(cp.allotmentPaymentId);

      return {
        ...cp,
        type: "AGREEMENT",

        allotmentPaymentData: allotment,
        leadData: lead,
        personData: person,
        inventoryDataForLead: inventory,
        projectData: project,
        wingData: wing,
        fosData: fos,
      };
    }

    // -------------------------
    // ✅ AOP / POP FLOW
    // -------------------------
    // -------------------------
    // ✅ AOP / POP FLOW (FINAL FIX)
    // -------------------------

    const key = `${cp.CpId}_${cp.projectId}_${cp.aopId || cp.popId}`;
    const bookingStates = cpBookingMap[key] || []; // ✅ ARRAY now

    // 🔥 create annexure rows (MULTIPLE)
    const annexureRows = bookingStates.map((bookingState) => {
      const allotment = allotmentPaymentMap[bookingState.allotment_payment_id];

      const lead = allotment
        ? leads.find(l => l.leadId === allotment.leadId)
        : null;

      const person = lead
        ? persons.find(p => p.personId === lead.personId)
        : null;

      const inventory = allotment
        ? inventoryData.find(i => i.unitId === allotment.unitId)
        : null;

      const wing = inventory
        ? wings.find(w => w.wingId === inventory.wingId)
        : null;

      const projectForRow = inventory
        ? projects.find(p => p.projectId === inventory.projectId)
        : project;

      return {
        leadName: applicantNameMap[bookingState.allotment_payment_id] || person?.name || "NA",
        leadDisplayId: lead?.leadDisplayId || null,
        projectName: projectForRow?.projectName || project?.projectName || "NA",
        projectShortCode: projectForRow?.projectShortCode || project?.projectShortCode || "NA",
        wingName: wing?.wingName || "NA",
        unitNo: inventory?.unitNo || "NA",
        agreementDate: agreementFormMap[bookingState.allotment_payment_id] || "NA",
        agreementValue:
          allotment?.Agreement_Value ||
          allotment?.agreementValue ||
          bookingState?.booking_value ||
          0,
        brokerageAmountBasic: isAOP
          ? bookingState?.aop_amount || 0
          : bookingState?.pop_amount || 0,
        brokeragePercentage: cp.Brokerage_Persentage || "NA",
      };
    });

    // 🔥 FINAL RETURN
    return {
      ...cp,
      type: isAOP ? "AOP" : isPOP ? "POP" : "OTHER",

      planName: isAOP
        ? aopPlanMap[cp.aopId]?.financial_year || "-"
        : isPOP
          ? popPlanMap[cp.popId]?.name || "-"
          : null,

      // ✅ ADD THIS
      aopStartDate: isAOP
        ? aopPlanMap[cp.aopId]?.validity_start_date || null
        : null,

      aopEndDate: isAOP
        ? aopPlanMap[cp.aopId]?.validity_end_date || null
        : null,

      popStartDate: isPOP
        ? popPlanMap[cp.popId]?.start_date || null
        : null,

      popEndDate: isPOP
        ? popPlanMap[cp.popId]?.end_date || null
        : null,

      projectData: project,
      annexureRows,
    };
  });


  // Step 9: Final filtering
  const startDate = selectedDates?.[0]?.value || null;
  const endDate = selectedDates?.[1]?.value || null;

  const filteredResult = cpPaymentsWithDetails
    .filter(Boolean)
    .filter(item => {
      const matchesStatus =
        selectedStatus.length === 0 || selectedStatus.includes(item.Status);

      const agreementDate = item?.AgreementDate;
      const matchesDate =
        (!startDate || new Date(agreementDate) >= new Date(startDate)) &&
        (!endDate || new Date(agreementDate) <= new Date(endDate));

      const matchesSearch =
        !isSearching ||
        (item?.personData?.name?.toLowerCase()?.includes(normalizedSearch)) ||
        (String(item?.personData?.contactNumber || "").includes(normalizedSearch)) ||
        (item?.leadData?.leadDisplayId?.toLowerCase()?.includes(normalizedSearch));

      return matchesStatus && matchesDate && matchesSearch;
    });

  return { data: filteredResult, count: filteredResult.length };
}

// async function getReraDocNumberForCP(cpId) {
//   const { data, error } = await supabase
//     .from("KycDocuments")
//     .select("docNumber")
//     .eq("docType", "Rera")
//     .eq("cpId", cpId)
//     .maybeSingle(); // if you expect only one RERA doc per CP

//   if (error) {
//     console.error("❌ Failed to fetch RERA doc:", error.message);
//     return null;
//   }

//   return data?.docNumber || null;
// }

async function getReraDocNumberForCP(cpId) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("docNumber")
    .eq("docType", "Rera")
    .eq("cpId", cpId)
    .maybeSingle();

  if (error) {
    console.error("❌ Failed to fetch RERA doc:", error.message);
    return null;
  }

  console.log("✅ RERA Doc Fetched for cpId:", cpId, "→", data);
  return data?.docNumber || null;
}


async function getCpInvoiceDetails(CPpaymentId) {
  const {
    data: CpInvoices,
    count,
    error,
  } = await supabase
    .from("CpInvoices")
    .select("*")
    .eq("CPpaymentId", CPpaymentId)
    .eq("isDeleted", false);

  if (error) throw error;

  return {
    data: [...CpInvoices],
  };
}

async function checkInvoiceNumberExists(CpId, invoiceNumber) {
  try {
    const { data, error } = await supabase
      .from("CpInvoices")
      .select("invoicesId")
      .eq("CpId", CpId)
      .eq("Cp_Invoice_Number", invoiceNumber)
      .neq("FV_Inword_Status", "REJECTED")
      .eq("isDeleted", false)

    if (error) throw error;

    return {
      exists: data.length > 0,
      data,
      error: null,
    };
  } catch (err) {
    console.error("Supabase error:", err.message);
    return {
      exists: false,
      data: null,
      error: err.message,
    };
  }
}

async function checkIfFVPaymentExists(CpInvoicesId) {
  const { data, error } = await supabase
    .from("CPFVPaymentsHistory")
    .select("CPFVPaymentID") // select only id for performance
    .eq("CpInvoicesId", CpInvoicesId)
    .limit(1);

  if (error) {
    console.error("Supabase error:", error);
    return 0; // or throw error based on your app's logic
  }

  return data.length > 0 ? 1 : 0;
}

async function getFVPaymentHistoryByCPpaymentId(CpInvoicesId) {
  const { data, error } = await supabase
    .from("CPFVPaymentsHistory")
    .select("*")
    .eq("CpInvoicesId", CpInvoicesId);

  if (error) {
    console.error("Supabase error:", error);
    return []; // or throw error if needed
  }
  console.log(data, "***");
  return data; // array of matching rows
}

export async function getSalesManagerName(leadID) {
  // Step 1: Get userId from Leads table
  const { data: leadData, error: leadError } = await supabase
    .from("Leads")
    .select("userId")
    .eq("leadId", leadID)
    .single();

  if (leadError || !leadData) {
    console.error("Lead fetch error:", leadError);
    return null;
  }

  const userId = leadData.userId;

  // Step 2: Use userId to get name from Users
  const { data: userData, error: userError } = await supabase
    .from("Users")
    .select("name")
    .eq("userId", userId)
    .single();

  if (userError || !userData) {
    console.error("User fetch error:", userError);
    return null;
  }

  console.log("salesManager", userData.name);
  return userData.name;
}


export async function getSalesManagerByCP(cpId) {
  // Step 1: Get userId from Leads table
  const { data: cpData, error: leadError } = await supabase
    .from("CP")
    .select("recommendedBySalesId")
    .eq("cpId", cpId)
    .single();

  if (leadError || !cpData) {
    console.error("Lead fetch error:", leadError);
    return null;
  }

  const userId = cpData.recommendedBySalesId;

  // Step 2: Use userId to get name from Users
  const { data: userData, error: userError } = await supabase
    .from("Users")
    .select("name")
    .eq("userId", userId)
    .single();

  if (userError || !userData) {
    console.error("User fetch error:", userError);
    return null;
  }

  console.log("salesManager", userData.name);
  return userData.name;
}
// async function updateCPaymentStatus(cpPaymentId,status) {
//  const { data: updateCPayment, error: updateCPError } =
//       await supabase
//        .from("CpPayments")
//        .update({
//             Status: "Pending",
//                })
//         .eq("id", cpPaymentId)
//         .eq("Status",status)// Update based on the unique identifier (e.g., id)
//         .select("*")

//      if (updateCPayment) {
//           console.error("Error updating CP row:", updateCPError);
//          } else {
//           console.log("CP Payment Row updated:", updateCPayment);
//          }
//   return updateCPayment;
// }

async function updateCPaymentStatus(cpPaymentId, currentStatus) {
  const { data: updateCPPayment, error: updateCPError } = await supabase
    .from("CpPayments")
    .update({
      Status: "Pending", // ✅ new status
    })
    .eq("id", cpPaymentId)
    .eq("Status", currentStatus) // ✅ condition: only if current status matches
    .select("id, Status"); // optional: select only what you need

  // ✅ Fix: Check for error, not data
  if (updateCPError) {
    console.error("Error updating CP row:", updateCPError);
    return null;
  } else if (!updateCPPayment || updateCPPayment.length === 0) {
    console.warn(
      `⚠️ No CP Payments matched for ID: ${cpPaymentId} and Status: ${currentStatus}`
    );
    return null;
  } else {
    console.log("CP Payment Row updated:", updateCPPayment);
  }

  return updateCPPayment;
}

async function updateCPaymentStatusBackToInvoicePending(cpPaymentId) {
  const { data, error } = await supabase
    .from("CpPayments")
    .update({ Status: "Pending For Invoice" })
    .eq("id", cpPaymentId)
    .select("id, Status");

  if (error) {
    console.error("❌ Error rolling back status:", error);
    return null;
  }

  return data;
}

export const getLatestCPPaymentStatus = async (cpPaymentId) => {
  const { data, error } = await supabase
    .from("CpPayments")
    .select("Status")
    .eq("id", cpPaymentId)
    .single();

  if (error) {
    throw error;
  }

  return data?.Status;
};



export const getApplicantsByAllotmentPaymentId = async (allotmentPaymentId) => {
  try {
    const { data, error } = await supabase
      .from("AgreementForm")
      .select("applicants")
      .eq("allotmentPaymentId", allotmentPaymentId)
      .single(); // Only one record expected per allotmentPaymentId

    if (error) throw error;
    return data?.applicants || [];
  } catch (err) {
    console.error("Error fetching applicants:", err);
    return [];
  }
};



async function sendWAMSG(obj) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE +
        "whatsapp/sendWaMsgOnLeadRegisteredDirect",
        obj
      )
      .then(async (resp) => {
        // console.log("login time===>", new Date());
        if (resp?.data?.success) {
          resolve({ success: true });
        } else {
          reject({ success: false });
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {

  getProfessions,
  getNationality,
  getProjects,
  addPersonTable,
  addLeadsTable,
  addLeadStatus,
  addKYCDoc,
  getLeads,
  getProjectUnitType,
  addProjectPrefernces,
  getUsers,
  checkPhoneNumberIsBlackListed,
  checkPhoneNumberExists,
  getAllProjects,
  getAllEvents,
  getTotalLeadsCount,
  getSiteVisitsCount,
  getTokensCount,
  getProjectsList,
  getAllAllotmentsCount,
  updateProjectPrefernce,
  updateCPaymentStatus,
  updateCPaymentStatusBackToInvoicePending,
  getLeadProjectPrefernce,
  getNative,
  getBudget,
  getFormatedEmail,
  getAllAgreementCount,
  checkLeadEmailExists,
  checkLeadEmailExistsInUsers,
  checkLeadEmailExistsInCp,
  addLeadLogs,
  getAllotedData,
  getAssignedProjects,
  getLeadDetails,
  sendWAMSG,
  getAgreementDoneLeads,
  getCpInvoiceDetails,
  checkInvoiceNumberExists,
  checkIfFVPaymentExists,
  getFVPaymentHistoryByCPpaymentId,
  getReraDocNumberForCP
};
